import {
  EmployeeHourAction,
  EmployeeHourState,
} from 'store/aggregated/employeeHour';
import { domainUtility } from 'utility';

const initialState: EmployeeHourState = { allIds: [], byId: {} };

const employeeHourReducer = (
  state: EmployeeHourState = initialState,
  action: EmployeeHourAction,
): EmployeeHourState => {
  switch (action.type) {
    case 'aggregated/employeeHour/ADD':
      return domainUtility.add(state, action.payload);
    case 'aggregated/employeeHour/SET':
      return domainUtility.set(state, action.payload);
    case 'aggregated/employeeHour/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'aggregated/employeeHour/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'aggregated/employeeHour/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default employeeHourReducer;
